import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { useMediaQuery, useTheme } from '@material-ui/core'
import { STATIC_CLASSES } from './Banner3.const'

export const useBanner3 = props => {
	const { metaData } = props

	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.image })
	const { handleFocus: handleMobileImageClick } = useFieldFocus({ metaData: metaData.mobileImage })
	const { handleFocus: handleTitleClick } = useFieldFocus({ metaData: metaData.title })
	const { handleFocus: handleSubtitleClick } = useFieldFocus({ metaData: metaData.subtitle })
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonAction })

	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	const { editable: titleEditable, handleChange: handleTitleChange } = useEditorMeta({
		metaData: metaData.title,
		key: 'title',
	})

	const { editable: subtitleEditable, handleChange: handleSubtitleChange } = useEditorMeta({
		metaData: metaData.subtitle,
		key: 'subtitle',
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaData.buttonText,
		key: 'buttonText',
	})

	const isMobileImage = isMobile && !!metaData.mobileImage?.image

	const image = isMobileImage ? metaData.mobileImage : metaData.image

	const isBackground = metaData.mobileImagePosition?.isBackgroundImage
	const isCenter = metaData.mobileImagePosition?.isCenterImage

	const isImageExist = !!image?.image

	return [
		{
			classes: STATIC_CLASSES,
			direction: isMobile
				? metaData.mobileImagePosition?.contentDirection()
				: metaData.imagePosition?.contentDirection(),

			image,
			withBgImage: isMobile && isBackground && isImageExist,
			isCenterImage: isMobile && isCenter && isImageExist,
			withImage: isMobile ? !isCenter && !isBackground && isImageExist : isImageExist,
			isMobile,
			opacity: isMobile ? metaData.mobileOpacity?.toNumber() : 0,
			marginMetaTop: metaData.overrideXsMargins?.toBoolean() ? metaData.xsMarginTop : metaData.marginTop,
			marginMetaBottom: metaData.overrideXsMargins?.toBoolean() ? metaData.xsMarginBottom : metaData.marginBottom,
			mobileAlignment: metaData.mobileAlignment,
			mobileButtonWidth: metaData.mobileButtonWidth,
			mobileImagePosition: metaData.mobileImagePosition,

			title: metaData.title?.metaValue,
			titleKey: metaData.title?.tierKey,
			titleConfig: metaData.title?.config,
			titleEditable,

			subtitle: metaData.subtitle?.metaValue,
			subtitleKey: metaData.subtitle?.tierKey,
			subtitleConfig: metaData.subtitle?.config,
			subtitleEditable,

			text: metaData.text?.metaValue,
			textKey: metaData.text?.tierKey,
			textConfig: metaData.text?.config,
			textEditable,

			buttonText: metaData.buttonText?.metaValue,
			buttonTextKey: metaData.buttonText?.tierKey,
			buttonTextConfig: metaData.buttonText?.config,
			buttonAction: metaData.buttonAction?.metaValue,
			buttonLink: metaData.buttonLink?.metaValue,
			buttonTextEditable,
		},
		{
			handleImageClick: isMobileImage ? handleMobileImageClick : handleImageClick,

			handleTitleClick,
			handleTitleChange,

			handleTextClick,
			handleTextChange,

			handleSubtitleClick,
			handleSubtitleChange,

			handleButtonClick,
			handleButtonTextChange,
		},
	]
}
